import { IApiService } from 'web_core_library';
import { CHALLENGE_LIST_SIZE, HIGHSCORES_LIST_SIZE } from './constants';
import { IHighscoresApiResponse } from './types';

export function createHighscoresService() {
  let ApiService: IApiService;

  /**
   * returns highscores for given exerciseId
   * @param exerciseId internal exericse name
   * @param page optional page number to fetch (by default fetches first page)
   * @param friends add filter flag to fetch friends highscores
   */
  const getExerciseHighscores = (exerciseId: string, page?: number, friends = false, isChallenge = false) => {
    const friendsFilter = friends ? 'friends' : '';
    let compiledFilter = isChallenge ? `limit/${CHALLENGE_LIST_SIZE}` : `limit/${HIGHSCORES_LIST_SIZE}`;
    if (page) {
      // set page if given
      compiledFilter = `page/${page}/${compiledFilter}`;
    }
    if (friendsFilter) {
      // add filter (friends, peer group etc.)
      compiledFilter = `${compiledFilter}/${friendsFilter}`;
    }
    return ApiService.action<IHighscoresApiResponse>('training_hiscore', {
      method: 'get',
      urlParams: {
        userId: ApiService.getUserId(),
        exerciseId,
        filter: compiledFilter,
      },
    });
  };

  const service = {
    init: (ApiServiceInstance: IApiService) => {
      ApiService = ApiServiceInstance;
    },
    getExerciseHighscores,
  };
  return service;
}

const HighscoresService = createHighscoresService();
export default HighscoresService;
